"use strict";

var _classCallCheck = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var stream_1 = require("stream");
/**
 * A very simple m3u8 playlist file parser that detects tags and segments.
 */


var m3u8Parser = /*#__PURE__*/function (_stream_1$Writable) {
  _inherits(m3u8Parser, _stream_1$Writable);

  var _super = _createSuper(m3u8Parser);

  function m3u8Parser() {
    var _this;

    _classCallCheck(this, m3u8Parser);

    _this = _super.call(this);
    _this._lastLine = '';
    _this._seq = 0;
    _this._nextItemDuration = null;
    _this._nextItemRange = null;
    _this._lastItemRangeEnd = 0;

    _this.on('finish', function () {
      _this._parseLine(_this._lastLine);

      _this.emit('end');
    });

    return _this;
  }

  _createClass(m3u8Parser, [{
    key: "_parseAttrList",
    value: function _parseAttrList(value) {
      var attrs = {};
      var regex = /([A-Z0-9-]+)=(?:"([^"]*?)"|([^,]*?))/g;
      var match;

      while ((match = regex.exec(value)) !== null) {
        attrs[match[1]] = match[2] || match[3];
      }

      return attrs;
    }
  }, {
    key: "_parseRange",
    value: function _parseRange(value) {
      if (!value) return null;
      var svalue = value.split('@');
      var start = svalue[1] ? parseInt(svalue[1]) : this._lastItemRangeEnd + 1;
      var end = start + parseInt(svalue[0]) - 1;
      var range = {
        start: start,
        end: end
      };
      this._lastItemRangeEnd = range.end;
      return range;
    }
  }, {
    key: "_parseLine",
    value: function _parseLine(line) {
      var match = line.match(/^#(EXT[A-Z0-9-]+)(?::(.*))?/);

      if (match) {
        // This is a tag.
        var tag = match[1];
        var value = match[2] || '';

        switch (tag) {
          case 'EXT-X-PROGRAM-DATE-TIME':
            this.emit('starttime', new Date(value).getTime());
            break;

          case 'EXT-X-MEDIA-SEQUENCE':
            this._seq = parseInt(value);
            break;

          case 'EXT-X-MAP':
            {
              var attrs = this._parseAttrList(value);

              if (!attrs.URI) {
                this.destroy(new Error('`EXT-X-MAP` found without required attribute `URI`'));
                return;
              }

              this.emit('item', {
                url: attrs.URI,
                seq: this._seq,
                init: true,
                duration: 0,
                range: this._parseRange(attrs.BYTERANGE)
              });
              break;
            }

          case 'EXT-X-BYTERANGE':
            {
              this._nextItemRange = this._parseRange(value);
              break;
            }

          case 'EXTINF':
            this._nextItemDuration = Math.round(parseFloat(value.split(',')[0]) * 1000);
            break;

          case 'EXT-X-ENDLIST':
            this.emit('endlist');
            break;
        }
      } else if (!/^#/.test(line) && line.trim()) {
        // This is a segment
        this.emit('item', {
          url: line.trim(),
          seq: this._seq++,
          duration: this._nextItemDuration,
          range: this._nextItemRange
        });
        this._nextItemRange = null;
      }
    }
  }, {
    key: "_write",
    value: function _write(chunk, encoding, callback) {
      var _this2 = this;

      var lines = chunk.toString('utf8').split('\n');

      if (this._lastLine) {
        lines[0] = this._lastLine + lines[0];
      }

      lines.forEach(function (line, i) {
        if (_this2.destroyed) return;

        if (i < lines.length - 1) {
          _this2._parseLine(line);
        } else {
          // Save the last line in case it has been broken up.
          _this2._lastLine = line;
        }
      });
      callback();
    }
  }]);

  return m3u8Parser;
}(stream_1.Writable);

exports.default = m3u8Parser;